import { createContext, useContext, useReducer } from 'react';
import { AmendmentListState, AmendmentListReducer, ACTION_TYPES } from './amendment-list-reducer';
import { IAmendmentPageRequest } from '../../../../model/scp/contract/amendment/request/amendment-paged-request';
import { useParams } from 'react-router-dom';

const AmendmentListContext = createContext<AmendmentListState | undefined>(undefined);
const AmendmentListDispatchContext = createContext({} as any);

const AmendmentListProvider = ({ children }: { children: React.ReactNode }) => {
    const { contractId } = useParams();

    const initialState: AmendmentListState = {
        parameters: {
            page: 1,
            pageSize: 100,
            contractId: Number(contractId)
        } as IAmendmentPageRequest,
        contractId: Number(contractId),
    };

    const [state, dispatch] = useReducer(AmendmentListReducer, initialState);

    return (
        <AmendmentListContext.Provider value={state}>
            <AmendmentListDispatchContext.Provider value={dispatch}>
                {children}
            </AmendmentListDispatchContext.Provider>
        </AmendmentListContext.Provider>
    );
}

const useAmendmentListState = () => {
    const context = useContext(AmendmentListContext);
    if (context === undefined) {
        throw new Error('useAmendmentListState must be used within a AmendmentListProvider');
    }
    return context;
}

const useAmendmentListDispatch = () => {
    const context = useContext(AmendmentListDispatchContext);
    if (context === undefined) {
        throw new Error('useAmendmentListDispatch must be used within a AmendmentListProvider');
    }
    return context;
}

export { AmendmentListProvider, useAmendmentListDispatch, useAmendmentListState, ACTION_TYPES };
